export default __webpack_public_path__ + "static/media/a1.7602e2b6.png";